// Estilo del portal de proyectos original. Son los componentes globales de index.css,
// que ahora usa toda la app.

export const botonPrimario = "btn-primario";
export const botonFantasma = "btn-fantasma";
export const botonPeligro = "btn-peligro";
export const pequeno = "btn-sm";
// Botón redondo con un solo símbolo (↓, ×, +).
export const icono = "!h-8 !w-8 !p-0 !text-sm";

export const campo = "campo";
export const etiqueta = "etiqueta";
export const insignia = "insignia";

export const antetitulo = "antetitulo";
export const tituloPagina = "titulo-pagina md:text-6xl";
export const tituloPanel = "titulo-panel";

export const panel = "panel";

export const pestana = (activa) => `pestana ${activa ? "pestana-activa" : ""}`;

export const filaResaltable = "fila-resaltable";

export const contenedor = "p-6";
